import * as React from 'react';

import {Checkbox} from '../checkbox/checkbox';

import styles from './reorderable-list-item.module.css';

type Props = {
    title: string;
    isRequireable: boolean;
    isRequired: boolean;
    isStatic?: boolean;
    onSetRequired: (arg1: boolean) => void;
};

export function ReorderableListItem(props: Props) {
    return (
        <div className='flex align-center full-height'>
            <div className={props.isStatic ? styles['container--static'] : styles.container}>
                <strong>{props.title}</strong>
                {props.isRequireable && (
                    <Checkbox
                        label='Required'
                        checked={props.isRequired}
                        onChange={props.onSetRequired}
                    />
                )}
            </div>
        </div>
    );
}
